import { render, staticRenderFns } from "./UserInfo.vue?vue&type=template&id=2dbf4b86"
import script from "./UserInfo.vue?vue&type=script&lang=js"
export * from "./UserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports